module.exports = __webpack_public_path__ + "img/ryt2.f03622ce.png";